import script from "./MfDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MfDetails.vue?vue&type=script&setup=true&lang=js"

import "./MfDetails.vue?vue&type=style&index=0&id=118bffa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-118bffa0"]])

export default __exports__